import React, { Component } from 'react';
import './menuPanel.less';
import MenuLinkCard from './menuLinkCard';
import _ from 'lodash';
import { ABSModal } from '../../../../../../components/ABSModal';
import ABSLogin from '../../../../account/Login';
import ABSResolvePhoneOrMail from '../../../../../../components/ABSResolvePhoneOrMail';
import ABSParagraph from '../../../../../../components/ABSParagraph';
import ABSSubTitle from '../../../../../../components/ABSSubTitle';

export interface IABSMenuPanelProps {
  menuItem: any;
  menuColor: string;
  menuColorIndex: number;
  hotMenu: any;
  login: boolean;
}

export interface IABSMenuPanelState {
  clickUrl: string;
}

const menuModalcontent = (
  <ABSParagraph>
    该功能仅对专业版用户开放，如果您有兴趣了解更多详情请与我们联系，电话：
    <ABSResolvePhoneOrMail />
    ，邮箱：
    <ABSResolvePhoneOrMail type="mail" />
    ，感谢您的关注与支持！
  </ABSParagraph>
);

class MenuPanel extends Component<IABSMenuPanelProps, IABSMenuPanelState> {
  menuModal;
  menuLogin;

  onShowMenuModal = () => {
    this.menuModal.show( true );
  }

  onShowMenuLogin = () => {
    this.menuLogin.show( true );
  }

  renderSunMenu = (menuItem: any, menuName: string) => {
    let menuList: any = [];
    const { hotMenu, menuColorIndex, login } = this.props;
    if (!menuItem || !Array.isArray(menuItem) || menuItem.length === 0) { return null; }
    menuItem.map((item, index) => {
      if (item && item.children && Array.isArray(item.children)) {
        const menuCard = item.children;
        menuCard.map((menuDetail) => {
          menuList.push(menuDetail);
        });
      }
    });
    if (menuList && menuList.length > 0) {
      // 行补全
      if (menuList.length % 3 !== 0) {
        const lenFor = 3 - menuList.length % 3;
        for (let i = 0; i < lenFor; i++) {
          menuList.push(null);
        }
      }
      
      // 计算title高度超过内容高度时，内容需要补全的个数
      let row;
      const titleHeight = (5 + 14) * menuName.length + 10; // （字间距 + 字高） * 字数 + padding-top
      const listHeight = menuList.length / 3 * 32; // （内容数量 / 列数） * 行高
      if (titleHeight > listHeight) {
        row =  Math.ceil(titleHeight / 32) * 3;
      }
      
      // title高度超过内容高度，不足的整体最终补全
      if (row) {
        const currentLen = menuList.length;
        for (let j = 0 ; j < row - currentLen; j++) {
          menuList.push(null);
        }
      }

      // 拿到补全数据 开始渲染菜单
      return menuList.map((menuDetail, menuIndex) => {
        if (menuDetail) {
          const showHot = _.find(hotMenu, { name : menuDetail.name });
          return <MenuLinkCard setClickUrl={this.setClickUrl} login={login} menuDetail={menuDetail} onShowMenuLogin={this.onShowMenuLogin} onShowMenuModal={this.onShowMenuModal} key={menuIndex} showHot={showHot} menuColorIndex={menuColorIndex}/>;
        } else {
          return <MenuLinkCard login={login} menuDetail={menuDetail} key={menuIndex} menuColorIndex={menuColorIndex}/>;
        }
      });
    } else {
      return null;
    }
  }

  renderMenuLogin = () => {
    return (
      <ABSLogin isHomeMenuLogin={true} getClickUrl={this.getClickUrl}/>
    );
  }

  setClickUrl = (clickUrl: string) => {
    this.setState({ clickUrl : clickUrl});
  }

  getClickUrl = () => {
    const { clickUrl } = this.state;
    return clickUrl;
  }

  render() {
    const { menuItem, menuColor } = this.props;
    return (
      <div className="abs-home-menu-panel" style={{border : `1px solid ${menuColor}`}}>
        <div className="abs-home-menu-panel-title" style={{backgroundColor : menuColor, whiteSpace: 'nowrap'}}>
          <ABSSubTitle title={menuItem.name} />
        </div>
        <div className="abs-home-menu-panel-submenu">
          {this.renderSunMenu(menuItem.children, menuItem.name)}
        </div>  
        <ABSModal
          content={menuModalcontent}
          width={360}
          footer={null}
          ref={view => this.menuModal = view}
        />
        <ABSModal
          content={this.renderMenuLogin()}
          width={500}
          footer={null}
          ref={view => this.menuLogin = view}
        />
      </div>
    );
  }
}

export default MenuPanel; 


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/abs/views/home/component/left/components/menuPanel.tsx